import React from "react";
import Expansion from "components/Expansion";
import ExpansionComponent from "components/ExpansionComponent";
import * as apis from "relay/event";
import Invitee from "./invitee";
import { parseDateToString, sortContactGroups } from "../../util";
import Button from "storybookComponents/Button";
import Picker from "storybookComponents/Picker";
import Icon from "storybookComponents/Icon";


const ScheduleForm = ({
  setFieldValue,
  values,
  propertyId,
  expanded,
  onChange,
  handleExpandedPanel,
  prevDate,
  invitedGroups,
  id,
  classes,
  getSubmitButtonState,
  timezoneString,
  timezoneAbbr,
  ...props
}) => {
  const [selected, setSelected] = React.useState([])
  const [date, setDate] = React.useState("");
  const [contactGroups, setContactGroups] = React.useState([]);
  const [innerExpanded, setExpanded] = React.useState("first")
  React.useEffect(() => {
    loadContactGroups();
  }, [1])


  React.useEffect(() => {
    let payload = {
      ...values,
      invitedGroups: values.invitedGroups.length ? values.invitedGroups.toString() : "",
      id
    }
    onChange(payload)
  }, [values])

  const handleInnerExpandedPanel = (panel) => {
    if (panel === innerExpanded)
      setExpanded("");
    else
      setExpanded(panel);
  };

  const loadContactGroups = async () => {
    try {
      const res = await apis.getContactGroups(propertyId);
      if (res.contactGroups) {
        let raw = []
        let _selected = invitedGroups ? JSON.parse(invitedGroups) : []

        for (let i = 0; i < res.contactGroups.length; i++) {
          if (_selected.indexOf(res.contactGroups[i].name) > -1) {
            raw.push(res.contactGroups[i])
          }
        }
        setSelected(raw.map(data => `${data.name} (${data.reachableCount})`));
        let filterGroup = res.contactGroups.filter(group => group.status !== "custom___hyblast");
        if (filterGroup) {
          setContactGroups(sortContactGroups(filterGroup));
        } else {
          setContactGroups([]);
        }
      }
    }
    catch (err) {
      console.log("contact group load error : ", err)
    }
  }


  const handleChange = (data, checked, obj) => {
    setSelected(checked ? [...selected, data] : selected.filter(i => i !== data));
    if (setFieldValue) {
      setFieldValue("invitedGroups", checked ? [...values.invitedGroups, obj.name] : values.invitedGroups.filter(i => i !== obj.name))
    }
  }

  const renderCheckBox = (data, index) => (
    <Invitee data={data} key={index} onChange={handleChange} selected={selected} />
  )

  const rightSectionContent = () => (
    <div className={classes.rightPart}>
      <div className={`${classes.displayFlexIcons}  ${(date || prevDate) && classes.dateMargin}`}>
        {
          prevDate ? <Icon type=" icon-n-check" className={classes.sentSuccess} /> : null
        }
        {(date || prevDate) ? <div className={`${classes.dateAlign}`}>{date ? date : prevDate ? parseDateToString(prevDate, timezoneString) : ""}</div> : null}
      </div>
      <div className={classes.brokersList}>{selected.toString().replace(/,/g, ", ")}</div>
    </div>
  )


  const handleDateChange = (value) => {
    if (value) {
      setDate(parseDateToString(value, timezoneString));
      setFieldValue("inviteScheduleAt", value.toISOString())
    }
    else {
      setFieldValue("inviteScheduleAt", "")
    }
  }

  return (
    <Expansion
      expanded={expanded === "Third"}
      name="Third"
      handleExpandedPanel={handleExpandedPanel}
      header="Send Invites Via Email & SMS"
      rightSection={open => !open ? rightSectionContent() : ""}
      headerIcon={open => prevDate && open ? <Icon type=" icon-n-check" className={classes.sentSuccess} /> : null}
    >
      <div>
        <ExpansionComponent
          expanded={innerExpanded === "first"}
          name="first"
          header="1. Select the invitees"
          handleExpandedPanel={handleInnerExpandedPanel}
          subtitle="Select the invitees you would like to send an invite via email/SMS"
        >
          {contactGroups.map(renderCheckBox)}
        </ExpansionComponent>
        <div className={classes.hrLine}></div>
        <ExpansionComponent
          expanded={innerExpanded === "second"}
          name="second"
          handleExpandedPanel={handleInnerExpandedPanel}
          header="2. Select a date & time"
          subtitle="Set a date and time to schedule the event invites to the above selected invitees"
        >
          <div id="hyly-datePicker" className={classes.textField} >
            <Picker timezoneString={timezoneString} format={true} type="datetime" icon={true} handleChange={handleDateChange} placeholderText="Date & Time" defaultValue={prevDate || ""} timezoneAbbr={timezoneAbbr} />
          </div>
        </ExpansionComponent>
        <Button className={classes.button} state={getSubmitButtonState("schedule")} onClick={props.handleSubmit} variant="primary" size="sm">Schedule Invites</Button>
      </div>
    </Expansion>
  )
}


export default ScheduleForm